import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { applyTheme, watchSystemTheme } from './lib/theme';
import { useMe } from './features/auth/useMe';
import { HomePage } from './features/home/HomePage';
import { SoloPage } from './features/reading/SoloPage';
import { SharedReadingPage } from './features/reading/SharedReadingPage';
import { RoomPage } from './features/room/RoomPage';
import { HistoryPage } from './features/history/HistoryPage';
import { ProfilePage } from './features/profile/ProfilePage';
import { LoginPage } from './features/auth/LoginPage';
import { WelcomePage } from './features/auth/WelcomePage';
import { InfoPage } from './features/info/InfoPage';
import { CardsPage } from './features/cards/CardsPage';
import { CardDetailPage } from './features/cards/CardDetailPage';
import { GlossaryPage } from './features/cards/GlossaryPage';
import { AppShell } from './components/AppShell';
import { TossAppBannerRoutes, TossOnlyRoutes } from './components/TossOnlyGate';
import { ScrollToTopButton, ScrollToTopOnNavigate } from './components/ScrollControls';
import { useSavePendingReading } from './features/reading/useAutoSave';

export default function App() {
  useThemeSync();
  useSavePendingReading(); // 로그인 전에 맡겨둔 결과를 로그인 후 자동 저장
  return (
    <AppShell>
      <ScrollToTopOnNavigate />
      <ScrollToTopButton />
      <Routes>
        {/* 서비스 화면 — 웹에서는 토스로 보내거나(모바일) 안내만 띄운다(PC). 미니앱은 그대로 */}
        <Route element={<TossOnlyRoutes />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/solo" element={<SoloPage />} />
          <Route path="/room/:roomId?" element={<RoomPage />} />
          <Route path="/r/:shareId" element={<SharedReadingPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
        {/* 읽을거리 — 웹에서도 열린다 (검색 유입·법적 고지). 위에 토스 안내만 얹는다 */}
        <Route element={<TossAppBannerRoutes />}>
          {/* 타로 안내는 용어 사전으로 통합 — 기존 링크·색인 보존용 리다이렉트 */}
          <Route path="/info/tarot" element={<Navigate to="/glossary" replace />} />
          <Route path="/info/:slug" element={<InfoPage />} />
          <Route path="/cards" element={<CardsPage />} />
          <Route path="/cards/:slug" element={<CardDetailPage />} />
          <Route path="/glossary" element={<GlossaryPage />} />
        </Route>
      </Routes>
    </AppShell>
  );
}

/** 화면 테마는 회원 전용 — DB(me.theme) 값 적용, 비회원·로그아웃은 기본(다크) */
function useThemeSync() {
  const { me, isLoading } = useMe();
  const theme = me?.theme ?? null;

  useEffect(() => {
    if (isLoading) return;
    applyTheme(theme);
    return watchSystemTheme(() => theme);
  }, [theme, isLoading]);
}
